import React from 'react';
import PropTypes from 'prop-types';

import ContextualString from '../../contextual/ContextualString';
import {
  ALBUM_PRICE_MODE,
  ALBUM_SUBTYPE,
  ALBUM_TYPE,
} from '../../../constants/albums';
import {
  getAccountCheckoutGreetingName,
  getAccountUsername,
} from '../../../util/account';
import { getAsset } from '../../../util/assets';
import Button from '../../global/Button';
import OnboardingLayoutContentNarrow from '../../../apps/temp/views/onboarding/OnboardingLayout/components/OnboardingLayoutContentNarrow';

const propTypes = {
  onGetStarted: PropTypes.func,
  stringContext: PropTypes.shape({
    id: PropTypes.string,
    album_type: PropTypes.oneOf(Object.values(ALBUM_TYPE)),
    album_subtype: PropTypes.oneOf(Object.values(ALBUM_SUBTYPE)),
  }),
};

const OnboardingLandingGeneric = ({ onGetStarted, stringContext }) => {
  const displayName = getAccountCheckoutGreetingName(stringContext.account);
  const username = getAccountUsername(stringContext.account);
  const isPpd = stringContext?.album_price_mode === ALBUM_PRICE_MODE.PPD_ONLY;
  const displayNameComponent = (() => {
    if (username) {
      return (
        <a href={`/@${username}`} className="text-sm mb-2">
          By {displayName}
        </a>
      );
    }
    return <p className="text-sm">By {displayName}</p>;
  })();

  return (
    <OnboardingLayoutContentNarrow>
      <h4 className="mb-1 text-center">Welcome to</h4>
      <h2 className="text-black mb-1 text-center">{stringContext.name}!</h2>

      {displayName && displayNameComponent}

      <p className="mb-0 text-center">
        <ContextualString
          id={
            isPpd
              ? 'albumDiscoveryEntryHeadlinePpd'
              : 'albumDiscoveryEntryHeadline'
          }
          type={stringContext?.album_type}
          subtype={stringContext?.album_subtype}
          values={{
            displayName,
          }}
        />
        <br />
        <br />
        <ContextualString
          id={isPpd ? 'albumDiscoveryEntryPpd' : 'albumDiscoveryEntry'}
          type={stringContext?.album_type}
          subtype={stringContext?.album_subtype}
        />
      </p>
      <img
        src={getAsset('/waldo-way.png')}
        height="140px"
        className="my-2"
        alt="Waldo Way"
      />
      <Button onClick={onGetStarted} className="mt-2" btnBlock>
        Let&apos;s Get Started!
      </Button>

      <div className="d-flex mt-1">
        <a href="/terms" target="_blank" className="m-auto text-xs">
          Terms of Use
        </a>
      </div>
    </OnboardingLayoutContentNarrow>
  );
};

OnboardingLandingGeneric.propTypes = propTypes;

export default OnboardingLandingGeneric;
